import clsx from 'clsx'
import React, { FC, useEffect, useRef, useState } from 'react'
import { useIntersection } from 'react-use'

import PartnersCarousel from '@/components/PartnersCarousel'

import DefaultComponentProps from '@/types/DefaultComponentProps'

import styles from './Section.module.scss'

export const Partners: FC<DefaultComponentProps> = ({ className = '' }) => {
  const [animationStart, setAnimationStart] = useState(false)

  const intersectionRef = useRef(null)

  const intersection = useIntersection(intersectionRef, {
    root: null,
    rootMargin: '0px',
    threshold: 0.4
  })

  useEffect(() => {
    if (intersection?.isIntersecting) {
      setAnimationStart(true)
    }
  }, [intersection?.isIntersecting])

  return (
    <section
      ref={intersectionRef}
      className={clsx(styles['section'], className, {
        [styles['section_animation-start']]: animationStart
      })}
    >
      <div className={styles['section__content']}>
        <PartnersCarousel />
      </div>
    </section>
  )
}
